import { CurrentCardService } from '@addins/core/core';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { CardToolsButton } from '../../schema/card-tools-button';
import { CardToolsProviderService } from '../card-tools-provider/card-tools-provider.service';

@Injectable({
  providedIn: 'root'
})
export class CardToolsButtonControllerService {
  private subs: Subscription[] = [];

  constructor(private cardTools: CardToolsProviderService, private currentCardService: CurrentCardService) {}

  setup(cardToolsButton: CardToolsButton) {
    this.updateCardToolsButtonVisibility(cardToolsButton);
    this.subs.push(this.cardTools.$change.subscribe(() => this.updateCardToolsButtonVisibility(cardToolsButton)));
    this.subs.push(cardToolsButton.onClick.subscribe(() => this.onCardToolsClicked()));
  }

  private updateCardToolsButtonVisibility(cardToolsButton: CardToolsButton) {
    cardToolsButton.show = !this.cardTools.isEmpty;
  }

  private onCardToolsClicked() {
    this.cardTools.showTools(this.currentCardService.current.ObjGuid);
  }

  cleanup() {
    while (this.subs.length > 0) {
      this.subs.pop().unsubscribe();
    }
  }
}
